<button class="button" [ngClass]="design" [disabled]="disabled"  (click)="buttonClicked.emit()">
    <app-icons *ngIf="icon && icon !== '' && icon.includes('left')" [design]="icon"></app-icons>
    <ng-content></ng-content>
    <app-icons *ngIf="icon && icon !== '' && !icon.includes('left')" [design]="icon"></app-icons>
</button>
